import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_3 = {
  key: 0,
  class: "formContainer"
}
const _hoisted_4 = {
  filter: "referenceID",
  sort: "year"
}
const _hoisted_5 = ["selectValues"]
const _hoisted_6 = ["selectValues"]
const _hoisted_7 = ["selectValues"]
const _hoisted_8 = ["selectValues"]
const _hoisted_9 = ["selectValues"]
const _hoisted_10 = {
  filter: "emissions",
  sort: "operationalEmissions"
}
const _hoisted_11 = {
  filter: "emissions",
  sort: "totalEmissions"
}
const _hoisted_12 = ["selectValues"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { colspan: "2" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: 'h1',
        localizedKey: "Data inventory",
        text: "Data inventory",
        class: "mb-0"
      }),
      (!_ctx.isReadOnly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "btn btn-tertiary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/activity-data-recorder')))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Add new activity",
                text: "Add new activity"
              })
            ]),
            (_ctx.datas.length > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-primary ms-2",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openMultipleDeleteModal()))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Delete multiple activities",
                    text: "Delete multiple activities"
                  })
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_op_table, {
            class: "table table-striped",
            items: _ctx.datas
          }, {
            default: _withCtx((opData) => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_4, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Reference ID",
                      text: "Reference ID"
                    })
                  ]),
                  _createElementVNode("td", {
                    filter: "year",
                    sort: "year",
                    filterType: "select",
                    selectValues: _ctx.filterYears
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Year",
                      text: "Year"
                    })
                  ], 8, _hoisted_5),
                  _createElementVNode("td", {
                    filter: "month",
                    sort: "month",
                    filterType: "select",
                    selectValues: _ctx.filterMonth
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Month",
                      text: "Month"
                    })
                  ], 8, _hoisted_6),
                  _createElementVNode("td", {
                    filter: "premisesType",
                    sort: "premisesType",
                    filterType: "select",
                    selectValues: _ctx.filterPremises
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Premises type",
                      text: "Premises type"
                    })
                  ], 8, _hoisted_7),
                  _createElementVNode("td", {
                    filter: "scope",
                    sort: "scope",
                    filterType: "select",
                    selectValues: _ctx.filterScopes
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Scope",
                      text: "Scope"
                    })
                  ], 8, _hoisted_8),
                  _createElementVNode("td", {
                    filter: "category",
                    sort: "category",
                    filterType: "select",
                    selectValues: _ctx.filterCategories
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Category",
                      text: "Category"
                    })
                  ], 8, _hoisted_9),
                  _createElementVNode("td", _hoisted_10, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Operational Emissions (kg CO2e)",
                      text: "Operational Emissions (kg CO2e)"
                    })
                  ]),
                  _createElementVNode("td", _hoisted_11, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Total Emissions (kg CO2e)",
                      text: "Total Emissions (kg CO2e)"
                    })
                  ]),
                  _createElementVNode("td", {
                    filter: "source",
                    sort: "source",
                    filterType: "select",
                    selectValues: _ctx.filterSources
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Source",
                      text: "Source"
                    })
                  ], 8, _hoisted_12),
                  _hoisted_13
                ])
              ]),
              _createElementVNode("tbody", null, [
                (opData.data.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                      _createElementVNode("td", _hoisted_15, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "No Elements Found",
                          text: "No Elements Found"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.data as OM.ActivityDataRecorderListVM[]), (item, i) => {
                  return (_openBlock(), _createElementBlock("tr", { key: i }, [
                    _createElementVNode("td", null, _toDisplayString(item.referenceID), 1),
                    _createElementVNode("td", null, _toDisplayString(item.year), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: item.month,
                        text: item.month
                      }, null, 8, ["localizedKey", "text"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.premisesType), 1),
                    _createElementVNode("td", null, _toDisplayString(item.scope), 1),
                    _createElementVNode("td", null, [
                      (item.category)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(item.category), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_17, "--"))
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$filters.currency(item.operationalEmissions)), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$filters.currency(item.totalEmissions)), 1),
                    _createElementVNode("td", null, [
                      (item.source)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(item.source), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_19, "--"))
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("button", {
                          class: "btn btn-tertiary me-1",
                          onClick: ($event: any) => (_ctx.openDetail(item.identifier))
                        }, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Detail",
                            text: "Detail"
                          })
                        ], 8, _hoisted_21),
                        (!_ctx.isReadOnly)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-primary ms-1",
                              onClick: ($event: any) => (_ctx.deleteActivity(item.identifier))
                            }, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "Delete",
                                text: "Delete"
                              })
                            ], 8, _hoisted_22))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["items"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}